/**
 * @module AEM
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
// core
import { Component, Input, OnInit, OnDestroy } from '@angular/core';
// Model
import { AuthorableComponent } from '@core/aem/models/authorable-component.model';
// Interface
import { AdaptiveImage } from './models/adaptive-image.interface';
import { Router } from '@angular/router';
import { FeatureToggleUtilService } from '@support/shared/services/feature-toggle-util.service';

@Component({
  selector: 'tmo-adaptive-image',
  templateUrl: './adaptive-image.html',
})
export class AdaptiveImageComponent
  extends AuthorableComponent<AdaptiveImage>
  implements OnInit, OnDestroy
{
  /**
   * Input HTML property
   */
  @Input() public html: string;
  /**
   * Input CSS property
   */
  @Input() public css: string;
  /**
   * Input image link url property
   */
  public desktopLinkUrl: string;
  /**
   * Input image link url property
   */
  public internalLink: boolean;
  /**
   * Input image url property
   */
  public desktopImageUrl: string;
  /**
   * Input image alt text property
   */
  public desktopAltText: string;

  // public showUpdatedBrowseDevices: boolean;

  constructor(
    private featureToggleUtilService: FeatureToggleUtilService,
    private router: Router
  ) {
    super();
    this.css = '';
    this.desktopLinkUrl = '';
    this.internalLink = false;
    this.desktopAltText = '';
    this.desktopImageUrl = '';
  }
  /**
   * Initialize Components
   */
  public ngOnInit(): void {
    // this.showUpdatedBrowseDevices = (SETTINGS.CHANNEL.toLowerCase() === CHANNELS.RETAIL);
  }
  /**
   * Method to set Image Attribute
   * @return void
   * @param {AdaptiveImage} data
   * @memberof AdaptiveImageComponent
   */
  public setData(data: AdaptiveImage): void {
    if (this.validate(data)) {
      this.desktopImageUrl = data.desktopImageUrl;
      this.desktopLinkUrl = data.desktopLinkUrl;
      if (this.desktopLinkUrl.startsWith('/')) {
        this.internalLink = true;
      } else {
        this.internalLink = false;
      }
      this.desktopAltText = data.desktopAltText;
    }
  }
  /**
   * Method to validate Image Parameter
   * @param {AdaptiveImage} data
   * @returns {boolean}
   * @memberof AdaptiveImageComponent
   */
  public validate(data: AdaptiveImage): boolean {
    if (data) {
      return true;
    } else {
      throw new Error(
        `TemplateComponent: Invalid params ${data}, required fields: desktopAltText, desktopImageUrl`
      );
    }
  }
  /**
   * Destory all subscriptions
   * @memberof AdaptiveImageComponent
   */
  public ngOnDestroy(): void {}

  public navigateToBrowseDevices(): void {
    // const isProductDetail = (this.desktopLinkUrl.indexOf('product-details') >= 0);
    // if (this.showUpdatedBrowseDevices && isProductDetail) {
    //   this.router.navigate(['/browse-phones'], { queryParams: { bannerAdDesc: this.desktopLinkUrl } });
    // }
    // else {
    this.router.navigate([this.desktopLinkUrl]);
    // }
  }
}
